import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { useParams } from "react-router-dom";
import ReportDocumentsGroup from "@app/components/setup/report-documents/group";
import notify from "@app/components/notify";

import store from "@app/state/store/report-document/report-documents";
import clientStore from "@app/state/store/clients/details";
import configClipboardStore from "@app/state/store/config-clipboard";

const ConfigurationReportDocuments = observer(({ className }) => {
    const { id } = useParams();

    useEffect(() => {
        store.setClientId(id);
        store.loadReportDocuments();

        return () => {
            store.reset();
        };
    }, [id]);

    if (!store.reportDocuments) {
        return;
    }

    const update = async (type, entry, args = {}) => {
        // reset the copy clipboard
        configClipboardStore.paste("reportDocument");

        try {
            await store.updateReportDocument(type, entry);
            await store.loadReportDocuments();
        } catch (ex) {
            const message = args.error || "Error saving the report document configuration";
            notify.error(message);
        }
    };

    const onCopy = (reportDocumentId) => {
        const copy = {
            id: reportDocumentId,
            sourceClientId: id,
        };
        configClipboardStore.copyReportDocument(copy);
    };

    const onPaste = async () => {
        const pasteData = configClipboardStore.paste("reportDocument");
        await clientStore.pasteReportDocument(id, pasteData);
        await store.loadReportDocuments();
    };

    const copied =
        configClipboardStore.reportDocument.id &&
        configClipboardStore.reportDocument.sourceClientId &&
        !configClipboardStore.reportDocument.sourceProjectId;

    return (
        <ReportDocumentsGroup
            list={store.reportDocuments}
            title="Document Templates"
            onChange={(type, entry) => {
                update(type, { client: id, ...entry });
            }}
            onCopy={onCopy}
            onPaste={onPaste}
            copied={copied}
            className={className}
        />
    );
});

export default ConfigurationReportDocuments;
